/*
 * Mobile menu category strip.
 * The menu tabs are a Slick slider, which also listens for swipes. Stop those
 * events at the strip so a sideways swipe scrolls the images natively instead
 * of switching tabs.
 */
(function () {
  var EVENTS = ['touchstart', 'mousedown'];

  function stop(event) {
    event.stopPropagation();
  }

  function init(root) {
    root.querySelectorAll('[data-menu-cats]').forEach(function (track) {
      if (track.dataset.menuCatsReady) return;
      track.dataset.menuCatsReady = 'true';
      EVENTS.forEach(function (name) {
        track.addEventListener(name, stop, { passive: true });
      });
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
